export const teamData = [
  {
    name: "CA Rajesh Balani",
    description: (
      <>
        <p>
          Rajesh Balani is working as the Finance Director at Soulscale
          Consulting. He oversees the financial management and audits of the
          fund-raising arms of Jan Sahas at USA and UK, apart from leading the
          Finance and Compliance vertical at GRI (Grassroots Resilience
          Institute).
        </p>
        <p>
          He is a Chartered Accountant by qualification and a Graduate in
          Commerce from Delhi University. Prior to Jan Sahas, he worked as the
          Team Leader at CPA Services, the Consulting Wing of the Financial
          Management Service Foundation (FMSF). Having an experience of more
          than 10 years in the development Sector, he has been involved with
          more than 200 National and International NGOs in supporting them in
          carrying out Financial Reviews, Investigations, Financial System
          development, and pre-funding Assessments helping the voluntary sector
          in setting up financial systems and Internal controls commensurate to
          the size and nature of the respective organizations.
        </p>
        <p>
          He specializes in the areas of Financial Management of NGOs, FCRA,
          Income Tax, GST, Setting up of an entity etc. and has also co-authored
          many training modules and resource materials for various partner NGOs
          in the areas of Income Tax, GST and FCRA. He has also been an expert
          faculty member for various online courses such as Certificate in
          Financial Management and Accountability (CFMA) and 21-day Crash course
          in FCRA. Some of the international NGOs he has worked with are as
          follows:
        </p>
        <ul>
          <li>Bread for the world, Germany </li>
          <li>Population Services International, USA</li>
          <li>VisionSpring, USA</li>
          <li>KinderNotHilfe, Germany</li>
          <li>Christian Blind Mission, Germany</li>
        </ul>
      </>
    ),
    image: "/images/placeholder.svg",
  },
  {
    name: "CA Shailesh Pandey",
    description: (
      <>
        <p>
          Shailesh Pandey spearheads the Finance Vertical at Jan Sahas as Sr
          Manager- Finance and has been associated with Jan Sahas Foundation
          since July 2022. He is a Chartered Accountant with significant
          experience acquired over the years in diverse areas encompassing
          audits, risk review & mitigation, internal/external audit functions,
          budgeting and forecasting, project administration, capacity building,
          finalisation of accounts & notes, due diligence, grants management,
          MIS, HR, taxation & statutory compliances etc. He also has experience
          handling internal and special audits to review compliances and
          procedures to accelerate internal financial and process controls.
        </p>
        <p>
          He has experience in income tax assessments before CIT, CIT(A) and
          ITAT. He has more than 12 years of rich experience and insights into
          the development sector. He has worked with significant donor
          organisations such as Global Fund, BMGF, USAID, EU, UNDP, EJAF, USAID,
          MacArthur, DFID, IDRC, GIZ, CDC, Shakti Foundation, ADB, New Venture
          Fund and different Indian Government Grants.
        </p>
        <p>
          Before joining Jan Sahas Foundation, he worked with Integrated
          Research and Action for Development (IRADe) Fondazione ACRA, Alliance
          India and Bansal & Co, Chartered Accountants.
        </p>
      </>
    ),
    image: "/images/placeholder.svg",
  },
  {
    name: "Mr. Ravinder Chauhan",
    description: (
      <>
        <p>
          Ravinder is working as the Lead-Finance at Jan Sahas. He is an
          MBA-Finance, CA Inter by qualification and a Graduate in Commerce from
          Delhi University. Having an experience of more than 15 years of
          experience in the Non-Profit and For-Profit Sectors. His involvement
          with Jan Sahas includes managing Capacity Building vertical known as
          Grassroots Resilience Institute (GRI).
        </p>
        <p>
          Prior to this, he has worked as Chief Finance Officer at Pardada
          Pardadi Education Society for a period of 8 years, wherein he oversaw
          overall financial management including but not limited to Fund
          Management, Accounting, Donor reporting, Facilitating Project and
          donor audits apart from fulfilling statutory compliances of the NGO.
          He has hands-on experience of working with the Accounts personnel
          supporting them in strengthening their financial systems.
        </p>
        <p>
          He has worked with significant donor organisations such as USAID, CAF
          – America, CAF - India, HCL Foundation, EY Foundation, Bharti
          Foundation, I-Partner India, Sahara Means Support, Axis Bank
          Foundation, Cargill, ASED, Give India, Genpact, Wockhardt Foundation.
        </p>
      </>
    ),
    image: "/images/placeholder.svg",
  },
  {
    name: "Dr. Siji Chacko",
    description: (
      <>
        <p>
          Dr. Siji Chacko serves as the Head – Climate Innovation &amp;
          Resilience at SoulScale Consulting. He leads the Climate Resilience
          and Innovation practice — providing technical and implementation
          support on heat resilience, cooling and hydration solutions, resilient
          housing, climate-risk insurance, and climate-responsive social
          protection for informal workers across.
        </p>
      </>
    ),
    image: "/images/SIJI.webp",
  },
];
